import tournamentService from '@/services/tournament';
import store from '@/store/index.js';
import day from 'dayjs';
import i18n from '@/i18n/index';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    tournament: {},
    matchScoresByGroupId: {},
  };
};
const state = initialState();

const getters = {
  tournament() {
    return state.tournament;
  },
  tournamentStatus() {
    return state.tournament.status;
  },
  matchScoresByGroupId(state) {
    return (groupId) => {
      if (state.matchScoresByGroupId[groupId]) {
        return state.matchScoresByGroupId[groupId];
      } else return [];
    };
  },
};

const actions = {
  async getTournamentById({commit, rootGetters}, id) {
    try {
      const currencySymbol = rootGetters['env/currencySymbol'];
      const result = await tournamentService.getTournamentById(id);
      result.groups.forEach((group) => {
        group.startedDate = day(group.startedAt).format('YYYY/MM/DD');
        group.startedTime = day(group.startedAt).format('HH：mm');
        // 防止prettier自動換行產生錯誤
        // prettier-ignore
        group.age =
            group.ageLowerBond > 0 && group.ageUpperBond > 0
              ? `${group.ageLowerBond > 0 ? group.ageLowerBond : i18n.t('不限')}-${ group.ageUpperBond > 0 ? group.ageUpperBond: i18n.t('不限')}` :  i18n.t('无限制');
        // prettier-ignore
        switch (group.gender) {
          case 'NONE':
            group.genderLabel =  i18n.t('无限制');
            break;
          case 'MALE':
            group.genderLabel =  i18n.t('男');
            break;
          case 'FEMALE':
            group.genderLabel =  i18n.t('女');
            break;
          case 'OTHER':
            group.genderLabel =  i18n.t('其他');
            break;
          default:
            group.genderLabel =  i18n.t('无限制');
            break;
        }
        group.roundLabel = i18n.t('{n}輪', {n: group.round});
        group.priceLabel = `${currencySymbol}${group.price}`;
        group.quota = group.quota > 0 ? group.quota : i18n.t('不限');
      });
      commit('setTournament', result);
      return result;
    } catch (error) {
      store.commit('env/setIsNotFound', true);
    }
  },
  async getMatchScores({commit, state}, {data, isUpdate, isSearch}) {
    if (state.matchScoresByGroupId[data.groupId] && !isUpdate && !isSearch)
      return state.matchScoresByGroupId[data.groupId];
    const result = await tournamentService.getMatchScores(data);
    commit('setMatchScores', {
      groupId: data.groupId,
      data: result.rows,
      isUpdate,
    });
    return result;
  },
};

const mutations = {
  setTournament(state, data) {
    state.tournament = data;
  },
  setMatchScores(state, {groupId, data, isUpdate}) {
    isUpdate
      ? state.matchScoresByGroupId[groupId].push(...data)
      : (state.matchScoresByGroupId[groupId] = data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
